import React from 'react'
import Form from '../../../../../packages/kiti/components/form/form/Form'
import SubmitBar from '../../../../../packages/kiti/components/form/SubmitBar'
import UseHandleSubmit from '../_helpers/handleSubmit'
import GeneralSection from '../sections/GeneralSection'

const AddSegwareTechnicianForm = () => {
  const [request, loading] = UseHandleSubmit()

  return (
    <Form loading={loading} onSubmit={request}>
      <GeneralSection />
      <SubmitBar loading={loading} />
    </Form>
  )
}

export default AddSegwareTechnicianForm
